// @flow

import React, { PureComponent } from 'react';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import urlUtil from 'app/common/lib/urlUtil';
import { Box, Icon, Text } from 'gestalt';

type Props = {|
  color: string,
  interest: string,
  onClick: (interest: string) => void,
|};

type State = {|
  isOnHover: boolean,
|};

export default class InterestQuery extends PureComponent<Props, State> {
  state = {
    isOnHover: false,
  };

  handleClick = () => {
    const { interest, onClick } = this.props;
    onClick(interest);
  };

  handleHover = () => {
    this.setState({ isOnHover: true });
  };

  handleUnhover = () => {
    this.setState({ isOnHover: false });
  };

  render() {
    const { color, interest } = this.props;
    const { isOnHover } = this.state;
    const searchQueryParams = urlUtil.getQueryStringFromObject({
      q: interest,
      rs: 'homefeed_interest_upsell',
      scope: 'pins',
    });

    return (
      /* eslint-disable jsx-a11y/mouse-events-have-key-events */
      <div
        onMouseOver={this.handleHover}
        onMouseOut={this.handleUnhover}
        style={{ borderRadius: 8 }}
      >
        {/* eslint-enable jsx-a11y/mouse-events-have-key-events */}
        <Box
          shape="rounded"
          marginLeft={1}
          marginRight={1}
          position="relative"
          dangerouslySetInlineStyle={{ __style: { backgroundColor: color } }}
        >
          <NavigateLink to={`/search/pins/?${searchQueryParams}`} onClick={this.handleClick}>
            <Box
              shape="rounded"
              position="absolute"
              display={isOnHover ? 'block' : 'none'}
              top
              right
              bottom
              left
              dangerouslySetInlineStyle={{ __style: { backgroundColor: 'rgba(0, 0, 0, .06)' } }}
            />
            <Box position="relative" display="flex" alignItems="center" paddingX={4} paddingY={3}>
              <Box marginRight={1} padding={1}>
                <Icon
                  icon="search"
                  accessibilityLabel={i18n._('search icon', 'icon label')}
                  color="white"
                  size={16}
                />
              </Box>
              <Text color="white" inline overflow="normal" size="lg" weight="bold">
                {`${interest.charAt(0).toUpperCase()}${interest.substr(1)}`}
              </Text>
            </Box>
          </NavigateLink>
        </Box>
      </div>
    );
  }
}
